import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { ConfirmationNumberOutlined }           from "@material-ui/icons";
import { default as React, FC }                 from "react";
import { useHistory }                           from "react-router";
import MenuType                                 from "../../../domain/menu/MenuType";

interface Props {
  menuType: MenuType
}

const MenuPlanButton: FC<Props> = (props: Props) => {
  const {menuType} = props;
  const history = useHistory();
  return (
    <>
      {
        menuType === MenuType.PLAN
          ?
          <section className="reska-menu-selected">
            <ListItem button={ true } divider={ true } onClick={ () => history.push("/plans") }>
              <ListItemIcon>
                <ConfirmationNumberOutlined/>
              </ListItemIcon>
              <ListItemText primary="プラン管理" className="reska-menu-selected-text"/>
            </ListItem>
          </section>
          :
          <ListItem button={ true } divider={ true } onClick={ () => history.push("/plans") }>
            <ListItemIcon>
              <ConfirmationNumberOutlined/>
            </ListItemIcon>
            <ListItemText primary="プラン管理"/>
          </ListItem>
      }
    </>
  );
};

export default MenuPlanButton;
